module.exports = "<app-custom-loader [showLoader]=\"loading\"> </app-custom-loader>"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/public-quote-home/public-quote-home.component.html
// module id = ../../../../../src/app/mnt-public-quote/public-quote-home/public-quote-home.component.html
// module chunks = mnt-public-quote.module